import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import { StrategyEx } from "@front/m19-models";
import { IButtonDirective, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import { StrategyListPreviewComponent } from "@m19-board/shared/strategy-list-preview/strategy-list-preview.component";

@Component({
  selector: "app-confirm-products-deletion-modal",
  imports: [TranslocoDirective, IButtonDirective, StrategyListPreviewComponent],
  templateUrl: "./confirm-products-deletion-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmProductsDeletionModalComponent {
  private readonly modalData = inject<ConfirmProductsDeletionModalData>(MODAL_DATA);
  private readonly translocoService = inject(TranslocoService);
  private readonly modalRef = inject(ModalRef);

  private productsToDelete = computed(() => this.modalData.productsToDelete);
  protected impactedStrats = computed(() => Array.from(this.modalData.impactedStrats.keys()));

  readonly message = computed(() => {
    const translationKey =
      this.productsToDelete().length > 1
        ? "product_delete_confirmation_multiple"
        : "product_delete_confirmation_single";

    return this.translocoService.translate("strategy-page." + translationKey, {
      count: this.impactedStrats().length,
    });
  });

  close() {
    this.modalRef.close();
  }

  confirm() {
    this.modalRef.close(true);
  }
}

export interface ConfirmProductsDeletionModalData {
  productsToDelete: string[];
  impactedStrats: Map<StrategyEx, string[]>;
}
